/**
 * Detect if running in Capacitor (mobile app)
 */
export const isCapacitorApp = () => {
  // window.Capacitor is defined on web too (the JS bridge), so we must
  // call isNativePlatform() to distinguish native Android/iOS from web.
  return (
    typeof window !== "undefined" &&
    window.Capacitor !== undefined &&
    typeof window.Capacitor.isNativePlatform === "function" &&
    window.Capacitor.isNativePlatform()
  );
};

/**
 * Open subscription checkout page
 * - Mobile: Opens in system browser (avoids app store fees)
 * - Web: Opens in new tab
 */
export const openCheckoutSession = async (url) => {
  if (isCapacitorApp()) {
    const { Browser } = await import("@capacitor/browser");
    await Browser.open({
      url: url,
      presentationStyle: "popover",
      toolbarColor: "#1f2937",
    });
  } else {
    window.open(url, "_blank");
  }
};

/**
 * Open Stripe Customer Portal
 */
export const openCustomerPortal = async (url) => {
  if (isCapacitorApp()) {
    const { Browser } = await import("@capacitor/browser");
    await Browser.open({
      url: url,
      presentationStyle: "popover",
      toolbarColor: "#1f2937",
    });
  } else {
    window.open(url, "_blank");
  }
};

/**
 * Open any external URL.
 * Mobile (Capacitor): system browser via Capacitor.Browser to avoid the
 * embedded WebView. Web: window.open in a new tab. Use this anywhere
 * you'd otherwise call window.open(url, "_blank") so mobile gets the
 * correct behavior.
 */
export const openExternalUrl = async (url) => {
  if (isCapacitorApp()) {
    try {
      const { Browser } = await import("@capacitor/browser");
      await Browser.open({
        url: url,
        presentationStyle: "popover",
        toolbarColor: "#1e3a28",
      });
      return;
    } catch (err) {
      // Fall through if Capacitor Browser fails for any reason
    }
  }
  window.open(url, "_blank");
};

export default {
  isCapacitorApp,
  openCheckoutSession,
  openCustomerPortal,
  openExternalUrl,
};
